var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import merge from 'lodash.merge';
import { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { FactoryComponent, FactoryInstance } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import useWatch from '../../../hooks/useWatch';
import { GenericComponent } from '../../atoms/GenericComponent';
import { TranslatedText } from '../../atoms/TranslatedText';
import { Tooltip } from '../../molecules/Tooltip';
function buildFormValidationProps(validations) {
    var _this = this;
    return Object.keys(validations).reduce(function (acc, key) {
        var _a;
        if (!validations[key]) {
            return acc;
        }
        var value = validations[key].value;
        var validation = FactoryInstance.getValidation(key);
        if (!value && !validation) {
            console.error("FormField is trying to use ".concat(key, " validation but it was not registered. Either pass a value or register validation."));
            return acc;
        }
        if (validation) {
            acc.validate[key] = function (value) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validation(value, validations[key])];
                    case 1: return [2 /*return*/, (_a.sent()) || key];
                }
            }); }); };
            return acc;
        }
        var valueOrRegex = ((_a = value.match) === null || _a === void 0 ? void 0 : _a.call(value, /^\/.*\/$/))
            ? new RegExp(value.replace(/\//g, ''), 'g')
            : value;
        acc[key] = { value: valueOrRegex, message: key };
        return acc;
    }, { validate: {} });
}
export var FormField = function (_a) {
    var _b;
    var design = _a.design, validations = _a.validations, disabled = _a.disabled, value = _a.value, schemaFromProps = _a.schema, props = __rest(_a, ["design", "validations", "disabled", "value", "schema"]);
    var _c = useDesign(design), _d = _c.config, designConfig = _d === void 0 ? {} : _d, components = _c.components, schema = _c.schema;
    var label = components.label, input = components.input, tooltip = components.tooltip, description = components.description, errorDesign = components.error;
    var name = ((_b = designConfig.input) === null || _b === void 0 ? void 0 : _b.name) || (props === null || props === void 0 ? void 0 : props.name);
    var config = merge({}, designConfig, props);
    if (!name) {
        throw new Error('Input name can`t be empty.');
    }
    var _e = useFormContext(), errors = _e.formState.errors, resetField = _e.resetField, setValue = _e.setValue;
    var watchedValues = useWatch(config.watch);
    var fieldValidations = useState(merge({}, validations, config.validations))[0];
    var formStateValidations = useState(buildFormValidationProps(fieldValidations))[0];
    useEffect(function () {
        if (disabled) {
            resetField(name);
        }
    }, [name, resetField, disabled]);
    var error = get(errors, name);
    var hasError = !isEmpty(error);
    var i18nError = useMemo(function () {
        if (!(error === null || error === void 0 ? void 0 : error.message))
            return {};
        var i18n = get(fieldValidations, error.message, {}).i18n;
        if (isEmpty(i18n))
            return {};
        i18n.values = { inputName: name };
        return { i18n: i18n };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error === null || error === void 0 ? void 0 : error.message]);
    // eslint-disable-next-line no-eval
    var shouldHide = config.shouldHide && eval("".concat(config.shouldHide, "(watchedValues)"));
    useEffect(function () {
        if (shouldHide &&
            !isEmpty(watchedValues) &&
            config.hiddenValue !== undefined &&
            config.hiddenValue !== null) {
            setValue(name, config.hiddenValue);
        }
    }, [shouldHide]);
    if (shouldHide)
        return null;
    return (_jsxs(GenericComponent, __assign({ disabled: disabled, schema: merge({}, schema, schemaFromProps), as: config.as, "data-design": design }, { children: [label && (_jsx(TranslatedText, __assign({ disabled: disabled, error: hasError, design: label, htmlFor: name }, config === null || config === void 0 ? void 0 : config.label))), _jsx(FactoryComponent, __assign({ design: input, error: hasError, disabled: disabled, value: value }, props, config === null || config === void 0 ? void 0 : config.input, formStateValidations, { name: name })), tooltip && (_jsx(Tooltip, { disabled: disabled, error: hasError, design: tooltip, config: config.tooltip, values: watchedValues })), !hasError && !!description && (_jsx(TranslatedText, __assign({ design: description }, config === null || config === void 0 ? void 0 : config.description))), hasError && (_jsx(TranslatedText, __assign({ error: hasError, design: errorDesign, values: watchedValues }, config === null || config === void 0 ? void 0 : config.error, i18nError)))] })));
};
FormField.displayName = 'FormField';
